import usePermissions, { ManagerRole } from './usePermissions';

/**
 * Whether the current user is partner staff — a manager of a partner (non-master)
 * service provider who is not a restaurant-owner (store) user (FOO-6351).
 *
 * "Partner" here is the tenant, not a role: see the terminology block in
 * PermissionResolver. This deliberately says nothing about `ManagerRole.Reseller`,
 * which is a FoodAmigos-side role and is not what any of this is about.
 *
 * This is the audience for the partner-channel restaurant-creation wizard: the
 * master provider keeps the legacy AddCompanyModal, and store users have no
 * creation entry point at all.
 *
 * Single source of truth so the wizard route guard (`IsPlgPartnerGuard`) and the
 * dashboard empty-state (`PartnerEmptyState`) can never drift apart.
 */
export default function useIsPartnerStaff() {
  const { isMasterProvider, hasAnyRole } = usePermissions();

  const isStoreUser = hasAnyRole([ManagerRole.StoreAdmin, ManagerRole.StoreEmployee, ManagerRole.StoreOperator], false);

  return !isMasterProvider && !isStoreUser;
}
